<template>
  <v-container>
    <v-row
      justify="center"
      no-gutters
    >
      <v-col cols="12">
        <v-list
          dense
          subheader
        >
          <v-subheader>Available Columns</v-subheader>
          <v-list-item
            v-for="(header, i) in availableHeaders"
            :key="`column-picker-${i}`"
            dense
            row
            style="width: 100%"
            justify-between
          >
            <v-list-item-content dense>
              {{ header.text }}
            </v-list-item-content>
            <v-list-item-action class="ma-0">
              <v-btn
                icon
                class="mx-0"
                @click.stop="toggleVisibility(header)"
              >
                <v-icon color="grey darken-2">
                  {{ isVisible(header) ? 'visibility' : 'visibility_off' }}
                </v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getHeaderKey } from './list.utils'

export default {
  props: {
    visibleColumns: {
      type: Array,
      required: true
    },
    availableHeaders: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      newColumn: null
    }
  },
  methods: {
    toggleVisibility(header) {
      const key = getHeaderKey(header)
      const columns = this.isVisible(key) ? this.visibleColumns.filter(x => x !== key) : [...this.visibleColumns, key]
      const newVisible = this.orderColumns(columns)
      this.$emit('newvisible', newVisible)
    },
    orderColumns(columns) {
      return this.availableHeaders.reduce((newList, column) => {
        if (columns.includes(column.value)) { newList.push(column.value) }
        return newList
      }, [])
    },
    isVisible(header) {
      const key = getHeaderKey(header)
      return this.visibleColumns.includes(key)
    }
  }
}
</script>
